export default __webpack_public_path__ + "static/media/logo_thothit.a422d24c.png";